export default {
    data() {
        return {
            hasSufficientTokens: true,
        };
    },

    mounted() {
        this.checkTokenBalance();

        this.$echo.private(`companies.${this.$auth.user.company.uuid}.tokens`).listen('.company.tokens.loaded', () => {
            this.checkTokenBalance();
        });
    },

    beforeDestroy() {
        this.$echo.leave(`companies.${this.$auth.user.company.uuid}.tokens`);
    },

    computed: {
        tokenType() {
            return this.$route.path.includes('bursaries') ? 'Bursary' : 'Job Posting';
        },
    },

    methods: {
        /**
         * Get the available job types that can be published
         * from the company's available token records and
         * check if it includes the specified token type.
         */
        checkTokenBalance() {
            this.$store
                .dispatch('tokenRecords/getRecords')
                .then((result) => {
                    this.hasSufficientTokens = result.filter((res) => res.type === this.tokenType).length > 0;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
